import classNames from 'classnames';
import type { HTMLAttributes } from 'react';
import { forwardRef } from 'react';

type StackProps = HTMLAttributes<HTMLDivElement> & { innerClassName?: string };
const Stack = forwardRef<HTMLDivElement, StackProps>(
  ({ children, innerClassName, className, ...props }, ref) => {
    return (
      <div
        className={classNames(
          'flex flex-col items-center justify-start gap-12 md:px-28 px-3 md:pt-40 pt-28 overflow-clip',
          className
        )}
        ref={ref}
        {...props}
      >
        <div
          className={classNames(
            'flex w-full max-w-screen-3xl flex-col items-center justify-center gap-12 text-jb-neutral-1000',
            innerClassName
          )}
        >
          {children}
        </div>
      </div>
    );
  }
);

Stack.displayName = 'Stack';
export default Stack;
